export default "__VITE_ASSET__c6064da1__"